export const getScrollContainer = () => document.getElementById('outer-router-container')! as HTMLDivElement;

export const smoothScrollApp = (x: number, y: number) =>
    getScrollContainer().scrollBy({ behavior: 'smooth', left: x, top: y });
